import { setLocale } from 'yup'
import i18n from 'i18next'

//NOTE: 初期化時にi18n.t()を発火する必要があるので関数型
const yupLocaleSetting = () => ({
  mixed: {
    required: i18n.t('validation.入力してください'),
    notType: ({ type }: { type: any }) =>
      type === 'number'
        ? i18n.t('validation.数字を入力してください')
        : i18n.t('validation.正しい形式を入力してください'),
  },
  string: {
    // eslint-disable-next-line
    min: i18n.t('validation.${min}文字以上にしてください'),
    // eslint-disable-next-line
    max: i18n.t('validation.${max}文字以内にしてください'),
    // eslint-disable-next-line
    length: i18n.t('validation.${length}文字入力してください'),
    email: i18n.t('validation.正しい形式にしてください'),
    url: i18n.t('validation.正しい形式にしてください'),
  },
  number: {
    // eslint-disable-next-line
    min: i18n.t('validation.${min}以上の値を入力してください'),
    // eslint-disable-next-line
    max: i18n.t('validation.${max}以下の値を入力してください'),
    integer: i18n.t('validation.整数を入力してください'),
  },
})

export const setYupLocale = () => setLocale(yupLocaleSetting())
